import Store from '../store/store'
import Beat from '../models/beat'
import ItemViewManager from './ItemViewManager'

export default class PlaylistManager {
    constructor(pagePlaylist = null, currentPlaylist = null, prevPlaylist = null) {
        this.audioManager = null
        // this.setAudioAnalyser()
        this.pagePlaylist = pagePlaylist
        this.currentPlaylist = currentPlaylist
        this.prevPlaylist = prevPlaylist
        this.playNextList = []
        this.volume = 0.9
    }

    setAudioManager (manager) {
        this.audioManager = manager
    }

    setAudioAnalyser () {
        //this.audioCtx = new AudioContext()
        this.audioCtx = new (window.AudioContext || window.webkitAudioContext)
        this.audioAnalyser = this.audioCtx.createAnalyser()
    }

    setPagePlaylist (playlist) {
        this.pagePlaylist = playlist
    }

    setCurrentPlaylist (playlist) {
        this.currentPlaylist = playlist
    }

    setPrevPlaylist (playlist) {
        this.prevPlaylist = playlist
    }

    setPagePlaylistToCurrent () {
        if (!this.currentPlaylist) {
            this.currentPlaylist = this.pagePlaylist
        } else if (this.currentPlaylist.getName() != this.pagePlaylist.getName()) {
            this.prevPlaylist = this.currentPlaylist
            this.currentPlaylist = this.pagePlaylist
        } else {
            this.currentPlaylist = this.pagePlaylist
            this.currentPlaylist.setFirstPlay(false)
        }

    }

    getCurrentPlaylist () {
        return this.currentPlaylist
    }

    getCurrentlyPlaying () {
        if (this.currentPlaylist)
            return this.currentPlaylist.playing

        return false
    }

    getPagePlaylist() {
        return this.pagePlaylist
    }

    getPlayNextList () {
        return this.playNextList
    }

    getNextInPlaylist() {
        if (this.playNextList.length > 0) {
            return this.playNextList[0]
        } else {
            return this.currentPlaylist.getNextInPlaylist()
        }
    }

    addToPagePlaylist(music) {
        if (this.pagePlaylist)
            this.pagePlaylist.addPlaylistItems(music)
    }

    emptyPagePlaylist() {
        if (this.pagePlaylist)
            this.pagePlaylist.emptyPlaylist()
    }

    removeMusicFromPlaylist (music) {
        if (this.pagePlaylist)
            this.pagePlaylist.removePlaylistItems(music)
    }

    isPlaying(music) {
        if (this.currentPlaylist && this.currentPlaylist.playing)
            return (music.id == this.currentPlaylist.playing.id && music.getType() == this.currentPlaylist.playing.getType())

        return false
    }

    addToPlayNext (music) {
        let newMusic = new Beat(jQuery.extend(true, {}, music));
        newMusic.inPlayNextList = true
        this.playNextList.push(newMusic)
    }

    playNext () {
        this.currentPlaylist.setFirstPlay(false)

        if (this.playNextList.length > 0) {
            this.play(this.playNextList[0])
        } else {
            if (Store.state.player.loop){
                this.play(this.currentPlaylist.getCurrentlyPlaying())
            } else {
                if (Store.state.player.random){
                    this.playRandom(this.currentPlaylist.playlist,this.currentPlaylist.getCurrentlyPlaying());
                } else {
                    this.play(this.currentPlaylist.getNextInPlaylist())
                }
            }
        }
    }

    playRandom (playList , currentlyPlaying) {
        var item = playList[Math.floor(Math.random() * playList.length)];
        let playing = currentlyPlaying;
        if (item.id == playing.id && item.getType() == playing.getType()){
            this.playRandom(playList , currentlyPlaying);
        } else {
            this.play(item);
        }
    }

    playPrev () {
        // if (this.currentPlaylist.isFirstPlay() && this.prevPlaylist) {
        //     this.currentPlaylist = this.prevPlaylist
        //     this.prevPlaylist = null
        //     this.playLastPlayed()
        // } else {
        this.play(this.currentPlaylist.getPrevInPlaylist())
        // }
    }

    playLastPlayed () {
        this.play(this.currentPlaylist.getLastPlayed())
    }

    play(music) {

        ItemViewManager.itemView();
        Store.commit("playerActiveItem", {activeItem: music})
        let notInNextList = true
        if (music.inPlayNextList) {
            for (var i = 0; i < this.playNextList.length; i++) {
                if (music.id == this.playNextList[i].id) {

                    this.audioManagerPlay(music)
                    this.currentPlaylist.addNext(this.playNextList[i])
                    this.currentPlaylist.setCurrentlyPlaying(this.playNextList[i])
                    this.playNextList.splice(i, 1)
                    notInNextList = false
                    return;
                }
            }
        }

        if (notInNextList) {
            for (var i = 0; i < this.currentPlaylist.getPlaylist().length; i++) {
                let currentItem = this.currentPlaylist.getPlaylist()[i]

                if (music.itemId == currentItem.itemId) {

                    this.audioManagerPlay(music)
                    this.currentPlaylist.setCurrentlyPlaying(currentItem)

                    for (var i = 0; i < this.playNextList.length; i++) {
                        if (music.id == this.playNextList[i].id) {
                            this.playNextList.splice(i, 1)
                            break;
                        }
                    }

                    return;
                }
            }
        }

        // In case music is not in playlist, this allows the music to play anyway
        this.audioManagerPlay(music)
        this.currentPlaylist.setCurrentlyPlaying(music)
    }

    pause(currentDuration) {
        if (!this.getCurrentlyPlaying()) {
            return
        }
        ItemViewManager.pause()
        let beat_id = this.getCurrentlyPlaying().id
        let duration = currentDuration
        this.audioManager.pause()
        Store.commit("playerActive", {active: false})
    }

    resume(music = null) {

        if (this.getCurrentlyPlaying()) {
            this.audioManager.play()
            Store.commit("playerActive", {active: true})
            return
        }

        if (music) {
            this.play(music)
        } else {
            this.playNext()
        }

        Store.commit("playerActive", {active: true})
    }

    seek(time) {
        this.audioManager.setCurrentTime(time)
    }

    changeVolume(value) {
        this.volume = value

        this.audioManager.setVolume(this.volume)
    }

     audioManagerPlay(music) {
            let self = this
            if (this.audioManager) {
                this.audioManager.pause()
                if (this.getCurrentlyPlaying() && this.getCurrentlyPlaying().id == music.id) {
                    this.audioManager.setCurrentTime(0)
                    self.audioManager.play()
                    self.audioManager.setVolume(self.volume)
                    Store.commit("playerActive", {active: true})
                } else {
                    this.audioManager.setCurrentTime(0)

                    let src = [
                        {src: music.http ? music.http : music.item.http, 'type': 'audio/mpeg'}
                    ]

                    if (music.hls && (this.isSafari() || Store.state.mobile)) {
                        src.unshift({src: music.hls, 'type': 'application/x-mpegURL'})
                    }

                    this.audioManager.setSrc(src)
                    this.audioManager.play()
                    this.audioManager.setVolume(this.volume)
                    Store.commit("playerActive", {active: true})
                }
                this.recordPlay(music)
            }
    }

    isSafari () {
        var ua = navigator.userAgent.toLowerCase();
        if (ua.indexOf('safari') != -1) {
            if (ua.indexOf('chrome') > -1) {
                return false;
            } else {
                return true;
            }
        }
    }

    recordPlay(music) {
        const musicType = music.getType() ? music.getType() : music.type
        const musicId = music.id ? music.id : music.item.id
        Store.state.app.$http.post(`/${musicType}s/${musicId}/play`)

        Store.state.eventTracker.play(music)
    }
}
